import { FirebaseError } from 'firebase/app';
import {
  // eslint-disable-next-line import/named
  UserCredential,
} from 'firebase/auth';

import { AuthProvider } from '../../auth';

import {
  errorChangePasswordEmailMessage,
  errorLoginMessage,
  resetPasswordErrorMessage,
} from './firestoreErrorUtils';

export interface SignInContextInterface {
  signIn: (
    username: string,
    password: string,
  ) => Promise<UserCredential | void>;
  resetPassword: (email: string) => Promise<void>;
  updateEmail: (email: string) => Promise<void>;
  updatePassword: (newPasswd: string, currentPasswd: string) => Promise<void>;
  addUserWithEmailAndPassword: (
    email: string,
    password: string,
  ) => Promise<UserCredential | undefined | void>;
}

export const SignInContext = () => {
  return {
    signIn: async (username: string, password: string) => {
      return await AuthProvider.signInWithEmailAndPassword(
        username,
        password,
      ).catch(error => {
        errorLoginMessage(error);
      });
    },

    resetPassword: async (email: string) => {
      return AuthProvider.resetPassword(email).catch(error => {
        resetPasswordErrorMessage(error);
      });
    },

    updateEmail: async (email: string) => {
      if (email) {
        return AuthProvider.updateEmail(email)?.catch(error => {
          errorChangePasswordEmailMessage(error);
        });
      }
    },

    updatePassword: async (newPasswd: string, currentPasswd: string) => {
      await AuthProvider.reauthenticateWithCredential(currentPasswd)
        .then(() => {
          return AuthProvider.updatePassword(newPasswd)?.catch(error => {
            throw new FirebaseError(error.code, error.message);
          });
        })
        .catch(error => {
          errorChangePasswordEmailMessage(error);
        });
    },

    addUserWithEmailAndPassword: async (email: string, password: string) => {
      if (!email || !password) {
        return;
      }

      try {
        const userC = await AuthProvider.createUserWithEmailAndPassword(
          email,
          password,
        );
        return userC;
      } catch (err) {
        errorLoginMessage(err);
      }
    },
  };
};
